module.exports = __webpack_public_path__ + "static/media/DogImage.94087812.webp";